/**
 * Get metadata from an IFD.
 * @param ifd - The IFD.
 * @returns The metadata.
 */
export function getMetadata(ifd) {
    return {
        tiff: {
            fields: ifd.fields,
            tags: ifd.map,
        },
        exif: ifd.exif,
    };
}
//# sourceMappingURL=getMetadata.js.map